import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=3e4750e5&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e4750e5')) {
      api.createRecord('3e4750e5', component.options)
    } else {
      api.reload('3e4750e5', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=3e4750e5&", function () {
      api.rerender('3e4750e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dbpPba5pKXu4/JS/comp/costHelpSixtyTage.vue"
export default component.exports